import _fragmentPageIndustryDetailTemplate from './_fragment-page-industry-detail-template'

const pageContentType = 'PageIndustryHotelPayments'

export default _fragmentPageIndustryDetailTemplate(pageContentType)
